import { getCustomer } from './customer';

const loadingStatus = {
	IDLE: 'idle',
	LOADING: 'loading',
	SUCCEEDED: 'succeeded',
	FAILED: 'failed',
};

const getHeaders = () => {
	return getCustomer().token ? { Authorization: `${getCustomer().token}` } : {};
};

// В dev с proxy запрос идёт на тот же origin — CORS не нужен
const isDevWithProxy =
	typeof window !== 'undefined' &&
	/^(https?:\/\/)?(localhost|127\.0\.0\.1)(:\d+)?$/.test(window.location.origin);

const SERVER_URL_FULL =
	process.env.REACT_APP_SERVER_URL ||
	process.env.REACT_APP_DEV_URL ||
	'https://rayanhalal.ru/site';

const SERVER_URL = isDevWithProxy ? '' : SERVER_URL_FULL;
const getBasePath = () => (isDevWithProxy ? '/site' : '');

/** База для img/asset URL: в dev через proxy (/site), иначе полный URL бэка */
const getAssetBase = () => (isDevWithProxy ? '/site' : SERVER_URL_FULL);

const fetcher = async (endpoint, options = {}) => {
	try {
		const basePath = getBasePath();
		const fullPath = basePath ? `${basePath}${endpoint.startsWith('/') ? endpoint : '/' + endpoint}` : `${SERVER_URL_FULL}${endpoint}`;
		const url = new URL(fullPath, isDevWithProxy ? window.location.origin : fullPath);
		const params = new URLSearchParams(url.search);
		params.set('store_id', getCustomer().store_id);
		const requestUrl = isDevWithProxy
			? `${url.pathname}?${params.toString()}`
			: `${url.origin}${url.pathname}?${params.toString()}`;
		const response = await fetch(requestUrl, {
			headers: getHeaders(),
			...options,
		});
		return response;
	} catch (e) {
		// TODO: logger
		alert(`Fatal error from fetcher: ${e.toString()}`);
	}
	return false;
};

export default fetcher;

export { SERVER_URL, SERVER_URL_FULL, getAssetBase, getHeaders, loadingStatus };
